<template>
  <div :class="{ 'overflow-hidden flex flex-col grow justify-around text-center': loading }">
    <div v-show="loading">
      <div v-if="!isDelay" :class="textSize">
        {{ label }}
        <Dotdotdot />
      </div>
    </div>
    <div v-show="!loading">
      <slot />
    </div>
  </div>
</template>

<script>
import Dotdotdot from '@/components/shared/ui/Dotdotdot.vue'

export default {
  components: {
    Dotdotdot
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'Loading'
    },
    textSize: {
      type: String,
      default: 'text-xl'
    },
    delayTime: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      isDelay: true
    }
  },
  created() {
    setTimeout(() => {
      this.isDelay = false
    }, this.delayTime)
  }
}
</script>
